import { Text, Grid } from '@simplywallst/ui-core';

import PositiveNegativeValue from '@/components/PositiveNegativeValue';

import { formatterPercentage } from '@/utilities/format';
import { CountryISO } from '@/constants/countries';

type Trend = 'positive' | 'negative' | 'neutral';

interface Props {
  market: CountryISO;
  marketMetric: number | null;
  portfolioMetric: number | null;
  portfolioTrend: Trend;
}

const getValue = (trend: Trend): number | null => {
  if (trend === 'positive') return 1;
  if (trend === 'negative') return -1;
  return null;
};

export const Metrics = ({
  market,
  marketMetric,
  portfolioMetric,
  portfolioTrend,
}: Props) => {
  return (
    <Grid
      templateColumns="max-content max-content"
      gap="36px"
      alignItems="start"
    >
      <Grid gap="2px">
        <Text typography="tiny" color="whiteRGBA" opacity={0.5}>
          Holdings
        </Text>
        <Text typography="smallStrong">
          <PositiveNegativeValue value={getValue(portfolioTrend)}>
            {formatterPercentage(portfolioMetric)}
          </PositiveNegativeValue>
        </Text>
      </Grid>
      <Grid gap="2px">
        <Text typography="tiny" color="whiteRGBA" opacity={0.5}>
          {market.toUpperCase()} Market
        </Text>
        <Text typography="smallStrong">
          {formatterPercentage(marketMetric)}
        </Text>
      </Grid>
    </Grid>
  );
};
